import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { verivyToken } from "../../actions/authAction/loginAction";
import OverlayLoading from "../../components/Loading/OverlayLoading";
import PATH_URL from "../../routers/path";
import { getDefaultAuthorizedPath, hasAnyPermission, isFullAccessProfile } from "../../utils/helpers/permissions";

export const isAuthExpired = (auth, now = Math.floor(Date.now() / 1000)) => {
  const expiresAt = Number(auth?.expires_at);
  return Number.isFinite(expiresAt) && expiresAt > 0 && now >= expiresAt;
};

export const isSuperAdminProfile = (profile) => isFullAccessProfile(profile);

export default function AppLayout({ children, needAuthenticated = false, requiredPermissions = [] }) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const dispatch = useDispatch();

  // Loading dari redux: state.auth.login.loading
  const isLoading = useSelector((state) => state?.auth?.login?.loading);
  const auth = useSelector((state) => state?.auth?.login?.auth);
  const profile = useSelector((state) => state?.auth?.login?.profile);

  const token = params.get("token");
  const locationPathname = location.pathname;

  // Verifikasi token (hanya ketika masuk /home + token ada)
  useEffect(() => {
    if (token && locationPathname === PATH_URL.DASHBOARD) {
      dispatch(verivyToken(token, navigate));
    }
  }, [token, locationPathname, dispatch, navigate]);

  // Cek token expired
  useEffect(() => {
    if (isAuthExpired(auth)) {
      localStorage.removeItem("auth");
      localStorage.removeItem("userProfile");
      navigate("/login", { replace: true });
    }
  }, [auth, navigate]);

  // Tampilkan loading ketika verifikasi token / auth loading
  if (isLoading) {
    return (
      <OverlayLoading
        isShow
        title="Menyiapkan ruang kerja"
        message="Akas sedang memuat data toko dan hak akses Anda."
      />
    );
  }
  // Cek autentikasi
  if (needAuthenticated && !auth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const isAllowed = hasAnyPermission(profile, requiredPermissions);

  if (needAuthenticated && !isAllowed) {
    const fallbackPath = getDefaultAuthorizedPath(profile);
    return <Navigate to={fallbackPath === location.pathname ? PATH_URL.PROFILE : fallbackPath} replace />;
  }

  return children;
}
